import {AxiosError, AxiosResponse} from 'axios';
import {AxiosErrorToast} from '../general/ReusableFunctions';
import {IApiDataResponse} from '../../dto/API.dto';
import axiosInstance from '../../axiosConfig';
import {iMediaQrToken} from '../../dto/MediaQrToken.dto';

export const StoreMediaDeviceQrCodeToken = async (
  company_id: number,
  station_id: number,
) => {
  return axiosInstance
    .post(`/v1/company/${company_id}/station/${station_id}/qr-token`)
    .then((response: AxiosResponse<IApiDataResponse<iMediaQrToken>>) => {
      return response.data.data;
    })
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error in creating demo');
      throw error;
    });
};
